import React from "react";
//import { useState, useEffect } from 'react';
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
} from "chart.js";
import { Bar } from "react-chartjs-2";

ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend
);

export const options = {
  scales: {
    y: {
      title: {
        display: true,
        text: "Total Days",
      },
    },
    x: {
      title: {
        display: true,
        text: "Year",
      },
    },
  },
  responsive: true,
  plugins: {
    legend: {
      position: "top",
    },

    title: {
      display: true,
      text: "Historic air quality graph - Pollution levels per year",
    },
  },
};

//const labels = ['Good', 'Moderate', 'Sensitive', 'Unhealthy', 'UnhealthV', 'Hazardous'];

function ChartAQI(aqi) {
  const data = {
    labels: ["2022"],
    datasets: [
      {
        label: "Good",
        data: [aqi.aqiQualityGood],
        backgroundColor: ["#009966"],
      },
      {
        label: "Moderate",
        data: [aqi.aqiQualityModerate],
        backgroundColor: ["#ffde33"],
      },
      {
        label: "Unhealthy for Sensitive Group",
        data: [aqi.aqiQualitySensitive],
        backgroundColor: ["#ff9933"],
      },
      {
        label: "Unhealthy",
        data: [aqi.aqiQualityUnhealthy],
        backgroundColor: ["#cc0033"],
      },
      {
        label: "Very Unhealthy",
        data: [aqi.aqiQualityUnhealthyV],
        backgroundColor: ["#660099"],
      },
      {
        label: "Hazardous",
        data: [aqi.aqiQualityHazardous],
        backgroundColor: ["#7e0023"],
      },
    ],
  };

  return <Bar options={options} data={data} />;
}

export default ChartAQI;
